export function listingMore() {
	document.querySelectorAll('[data-listing-more]').forEach((root) => {
		const trigger = root.querySelector('.js-listing-more-trigger')
		const list = root.querySelector('#listing')
		if (!trigger || !list) return

		trigger.addEventListener('click', () => {
			list.querySelectorAll(':scope > [hidden]').forEach((el) => {
				el.removeAttribute('hidden')
			})

			trigger.setAttribute('aria-expanded', 'true')

			const footer = trigger.closest('.section__footer')
			if (footer) footer.remove()
			else trigger.remove()
		})
	})
}
